import * as React from 'react';
import { useSelector } from 'react-redux';
import { getRegions } from '../../selectors/developerV2/getRegions';
import { RegionChips } from '../../components/RegionChips';
import { getFilterRegionId } from '../../selectors';

export const Regions = () => {
  const regions = useSelector(getRegions);
  const currentRegionId = useSelector(getFilterRegionId);

  return <RegionChips regions={regions} currentRegionId={currentRegionId} />;
};
